import { ComponentType } from 'react';

import FileNewHireReportModal from 'modules/Tasks/SubmitActions/customComponents/FileNewHireReportModal';
import ReconnectGustoModal from 'modules/Tasks/SubmitActions/customComponents/ReconnectGustoModal';
import ReconnectPlaidModal from 'modules/Tasks/SubmitActions/customComponents/ReconnectPlaidModal';
import ReconnectQuilttModal from 'modules/Tasks/SubmitActions/customComponents/ReconnectQuilttModal';
import RecordFeesAndFranchiseTaxPaymentTask from 'modules/Tasks/SubmitActions/customComponents/RecordFeesAndFranchiseTaxPaymentTask';
import RecordQTEPaymentTask from 'modules/Tasks/SubmitActions/customComponents/RecordQTEPaymentTask';
import SignSS4Modal from 'modules/Tasks/SubmitActions/customComponents/SignSS4Modal';
import { SubmitActionTask } from 'modules/Tasks/types';

type CustomTaskComponent = ComponentType<{
    open: boolean;
    onClose: () => void;
    task: SubmitActionTask;
}>;

// Custom task components register here as they ship.
// Example: upload_missing_bank_statement: BankStatementUpload,
const customComponentRegistry: Record<string, CustomTaskComponent> = {
    file_new_hire_report: FileNewHireReportModal,
    reconnect_gusto_payroll: ReconnectGustoModal,
    reconnect_plaid_account: ReconnectPlaidModal,
    reconnect_quiltt_institution: ReconnectQuilttModal,
    record_fees_and_franchise_tax_payment: RecordFeesAndFranchiseTaxPaymentTask,
    record_qte_payment: RecordQTEPaymentTask,
    sign_ss4: SignSS4Modal,
};

export function isLegacyBannerCustomTask(task: {
    task_template: { has_custom_component: boolean; submit_action: { type: string; component_name?: string } };
}): boolean {
    const { has_custom_component: hasCustomComponent, submit_action: submit } = task.task_template;

    return (
        hasCustomComponent &&
        submit.type === 'custom' &&
        typeof submit.component_name === 'string' &&
        submit.component_name in customComponentRegistry
    );
}

export default customComponentRegistry;
